<template>
  <div class="select-ele-div">
    <!-- 通用的表单 select元素 -->
    <label class="popup-label">{{ eleData.labelName }}</label>
    <div class="float-right">
      <select v-model.number="eleData.value" @change="changeFn">
        <option v-for="(opt, index) in opts" :key="index" :value="opt.val + ''">
          {{ opt.desc }}
        </option>
      </select>
      <em class="upArrowIcon" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'CmCommonSelect',
  components: {},
  props: {
    eleData: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {}
  },
  computed: {
    value() {
      return this.eleData.value
    },
    opts() {
      var me = this
      var opts = this.eleData.opts

      if (
        opts.length &&
        opts.every(function(ele) {
          return ele && ele.val != me.eleData.value
        })
      ) {
        me.eleData.value = opts[0] && opts[0].val
      }
      return opts
    }
  },
  methods: {
    changeFn() {
      this.$emit('changeEleData', this)
    }
  }
}
</script>

<style lang="postcss" scoped>
select {
  width: 100%;
  line-height: normal;
  font-size: 0.28rem;
  height: 0.54rem;
  padding: 0 0.12rem;
  appearance: none;
  min-width: 2.56rem;
  border: 1px solid #e5e5e5;
  border-radius: 0.04rem;
  vertical-align: middle;
  color: #666;
  background: transparent;
  &.disabled {
    color: #ccc !important;
  }
}
.select-ele-div {
  position: relative;
  width: 100%;
  line-height: 0.92rem;
  em.upArrowIcon {
    position: absolute;
    top: 50%;
    right: 0.16rem;
    display: inline-block;
    margin-top: -0.08rem;
    border-width: 0.06rem !important;
    border-right: 0.06rem solid #666;
    border-bottom: 0.06rem solid #666;
    border-left: 0.06rem solid transparent;
    border-top: 0.06rem solid transparent;
    transform: rotate(45deg);
    pointer-events: none;
  }
  .popup-label {
    width: 2.56rem;
    margin-right: 0.24rem;
    line-height: 0.96rem;
    display: inline-block;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    vertical-align: middle;
  }
  .float-right {
    position: relative;
    float: right;
    font-size: 0;
    line-height: 0.92rem;
  }
}
</style>
